var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDailyQuizzes = function SvgDailyQuizzes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#daily-quizzes_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A09EE7",
    d: "M35.435 21.871c-4.812-1.803-9.63-1.636-14.437.495v.775-.775c-4.81-2.133-9.63-2.296-14.437-.495a1.87 1.87 0 0 0-1.21 1.752V40.78c0 .7.697 1.192 1.355.951 4.35-1.594 8.707-1.58 13.06.046a3.52 3.52 0 0 0 2.464 0c4.35-1.625 8.707-1.64 13.06-.046a1.01 1.01 0 0 0 1.355-.95V23.622a1.87 1.87 0 0 0-1.21-1.752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__b)",
    d: "M20.998 37.093v3.34c-4.286-1.9-8.58-2.065-12.863-.495a.91.91 0 0 1-1.219-.855v-3.34a.91.91 0 0 0 1.219.856c4.284-1.57 8.577-1.406 12.863.494"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__c)",
    d: "M35.08 35.744v3.339a.908.908 0 0 1-1.218.856c-4.288-1.571-8.582-1.406-12.864.493v-3.339c4.282-1.899 8.576-2.065 12.863-.494a.91.91 0 0 0 1.22-.855"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__d)",
    d: "M33.862 39.017c-4.288-1.57-8.582-1.405-12.864.494-4.286-1.9-8.58-2.064-12.863-.494a.91.91 0 0 1-1.219-.855v.92a.91.91 0 0 0 1.219.855c4.284-1.57 8.577-1.406 12.863.493 4.282-1.899 8.576-2.064 12.863-.493a.908.908 0 0 0 1.22-.856v-.92a.908.908 0 0 1-1.22.856"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__e)",
    d: "M6.916 22.352v15.085a.91.91 0 0 0 1.219.856c4.284-1.57 8.577-1.407 12.863.494V21.22c-4.33-1.92-8.666-2.067-12.994-.445a1.68 1.68 0 0 0-1.088 1.577"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__f)",
    d: "M20.998 21.22v17.567c4.282-1.9 8.575-2.065 12.863-.494a.91.91 0 0 0 1.22-.856V22.35c0-.7-.433-1.33-1.09-1.576-4.33-1.623-8.667-1.473-12.993.445"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C5F1",
    d: "M33.349 29.431a17 17 0 0 0-2.704-.552.797.797 0 0 0-.895.788v5.584c0 .406.305.746.709.79q1.26.135 2.517.469a.684.684 0 0 0 .864-.659v-5.763c0-.304-.2-.573-.491-.657M9.728 30.09a16.2 16.2 0 0 1 5.91-.473.683.683 0 0 0 .755-.68V23.13a.68.68 0 0 0-.6-.678q-3.218-.372-6.435.559a.684.684 0 0 0-.493.657v5.763c0 .45.427.775.863.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECFA",
    d: "M8.778 34.002a.592.592 0 0 1-.184-1.155c3.474-1.133 6.998-1.16 10.473-.081a.592.592 0 0 1-.352 1.13c-3.236-1.004-6.517-.978-9.753.077a.6.6 0 0 1-.184.03M8.778 36.477a.592.592 0 0 1-.184-1.155c3.474-1.133 6.998-1.16 10.473-.082a.592.592 0 0 1-.352 1.131c-3.236-1.004-6.517-.978-9.753.077a.6.6 0 0 1-.184.03M29.131 32.569a.594.594 0 0 1-.595.593 16 16 0 0 0-4.942.81.59.59 0 0 1-.746-.379.593.593 0 0 1 .379-.747 17.2 17.2 0 0 1 5.315-.87.59.59 0 0 1 .59.593M29.131 35.042c0 .328-.267.59-.595.592-1.65.007-3.302.278-4.942.812a.59.59 0 0 1-.746-.38.593.593 0 0 1 .379-.747 17.3 17.3 0 0 1 5.315-.87.59.59 0 0 1 .59.593M23.41 28.998a.592.592 0 0 1-.183-1.155c3.474-1.133 6.997-1.16 10.472-.081a.592.592 0 1 1-.35 1.13c-3.237-1.004-6.518-.978-9.755.077a.6.6 0 0 1-.183.03M29.131 30.04a.594.594 0 0 1-.595.593 16 16 0 0 0-4.942.81.59.59 0 0 1-.746-.38.593.593 0 0 1 .379-.746 17.2 17.2 0 0 1 5.315-.87.59.59 0 0 1 .59.593M23.41 23.999a.592.592 0 0 1-.183-1.156c3.474-1.133 6.997-1.16 10.472-.081a.592.592 0 1 1-.35 1.13c-3.237-1.004-6.518-.978-9.755.077a.6.6 0 0 1-.183.03M23.41 26.473a.592.592 0 0 1-.183-1.155c2.382-.777 4.8-1.037 7.186-.773a.593.593 0 0 1-.13 1.177c-2.218-.245-4.468-.002-6.689.722a.6.6 0 0 1-.183.03"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB50",
    d: "M31.49 10.491C31.49 4.697 26.793.001 20.999 0a10.48 10.48 0 0 0-10.491 10.44 10.46 10.46 0 0 0 3.459 7.836 7.77 7.77 0 0 1 2.544 5.771h8.976c0-2.218.954-4.317 2.59-5.813a10.46 10.46 0 0 0 3.413-7.743"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#daily-quizzes_svg__g)",
    d: "M20.998 31.036a3.088 3.088 0 1 0 0-6.177 3.088 3.088 0 0 0 0 6.177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDCECE",
    d: "M24.729 28h-7.465c-.838 0-1.518-.588-1.518-1.312s.68-1.313 1.518-1.313h7.465c.838 0 1.517.588 1.517 1.313 0 .724-.68 1.312-1.517 1.312"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEEFF4",
    d: "M24.744 25.858H17.25a1.524 1.524 0 0 1 0-3.047h7.494a1.524 1.524 0 0 1 0 3.047"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB50",
    d: "M35 10.072c0-.73.591-1.32 1.32-1.32h2.745a1.32 1.32 0 0 1 0 2.64H36.32a1.32 1.32 0 0 1-1.32-1.32M34.316 6.259a1.32 1.32 0 0 1 0-1.867l1.941-1.941a1.32 1.32 0 0 1 1.867 1.867l-1.941 1.94a1.32 1.32 0 0 1-1.867 0M34.512 12.64a1.32 1.32 0 0 1 1.866 0l1.941 1.941a1.32 1.32 0 0 1-1.867 1.867l-1.94-1.94a1.32 1.32 0 0 1 0-1.867M6.78 9.66a1.32 1.32 0 0 0-1.32-1.32H2.713a1.32 1.32 0 0 0 0 2.64H5.46a1.32 1.32 0 0 0 1.32-1.32M7.678 6.259a1.32 1.32 0 0 0 0-1.867L5.738 2.45A1.32 1.32 0 0 0 3.87 4.318l1.94 1.94a1.32 1.32 0 0 0 1.867 0M7.678 13.06a1.32 1.32 0 0 0-1.866 0L3.87 15.001a1.32 1.32 0 0 0 1.867 1.867l1.94-1.94a1.32 1.32 0 0 0 0-1.868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__b",
    x1: 12.238,
    x2: 14.319,
    y1: 29.216,
    y2: 40.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__c",
    x1: 25.415,
    x2: 28.464,
    y1: 30.383,
    y2: 39.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__d",
    x1: 20.786,
    x2: 21.318,
    y1: 43.017,
    y2: 32.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7B7F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7B7F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__e",
    x1: 7.404,
    x2: 24.402,
    y1: 25.734,
    y2: 35.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__f",
    x1: 20.562,
    x2: 36.958,
    y1: 25.703,
    y2: 35.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC8FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "daily-quizzes_svg__g",
    x1: 20.998,
    x2: 20.998,
    y1: 26.612,
    y2: 29.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "daily-quizzes_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgDailyQuizzes;